import { render, staticRenderFns } from "./SistemaMenuIndex.vue?vue&type=template&id=377f9059"
import script from "./SistemaMenuIndex.vue?vue&type=script&lang=js"
export * from "./SistemaMenuIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports